module.exports = __webpack_public_path__ + "img/collection-engagementRingsLabGrownDiamonds@2x.ef6e10d.jpg";